import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Secure = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Secure' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M7,11 L7,6 C7,3 9,1 12,1 C15,1 17,3 17,6 L17,11 M12,23 C15.8659932,23 19,19.8659932 19,16 C19,12.1340068 15.8659932,9 12,9 C8.13400675,9 5,12.1340068 5,16 C5,19.8659932 8.13400675,23 12,23 Z M12,15 L12,19 M12,16 C12.5522847,16 13,15.5522847 13,15 C13,14.4477153 12.5522847,14 12,14 C11.4477153,14 11,14.4477153 11,15 C11,15.5522847 11.4477153,16 12,16 Z' />
  </StyledIcon>
);
